import { render, staticRenderFns } from "./MailManagementDetail.vue?vue&type=template&id=271cb728&"
import script from "./MailManagementDetail.vue?vue&type=script&lang=js&"
export * from "./MailManagementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports